import { render, staticRenderFns } from "./SupervisorDashboard5.vue?vue&type=template&id=54be2997&scoped=true&"
import script from "./SupervisorDashboard5.vue?vue&type=script&lang=js&"
export * from "./SupervisorDashboard5.vue?vue&type=script&lang=js&"
import style0 from "./SupervisorDashboard5.vue?vue&type=style&index=0&id=54be2997&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54be2997",
  null
  
)

export default component.exports